import React, { useState, useRef } from "react";

const sections = [
  { id: "overview", label: "Overview" },
  { id: "objectives", label: "Objectives" },
  { id: "eligibility", label: "Eligibility" },
  { id: "application-procedure", label: "Application Procedure" },
  { id: "career-options", label: "Career Options" },
  { id: "outcomes", label: "Apply Now" },
];

const NavItem = ({ id, label, onClick, showLine, isActive, navRef }) => (
  <li
    onClick={() => onClick(id)}
    className="cursor-pointer"
  >
    <div className="flex space-x-3 items-center">
      <div>
        <img
          src="/image-fix/pointers/tick-2-svgrepo-com.svg"
          alt="pointer"
          className="h-5 w-5"
        />
      </div>
      <p
        className={`border-b-2 ${
          isActive
            ? "border-sdorange text-white"
            : "border-transparent text-gray-300 hover:text-gray-500 hover:border-sdorange"
        }`}
      >
        {label}
      </p>
    </div>
    {showLine && <div className="ml-2 h-10 w-0.5 bg-sdorange my-1"></div>}
  </li>
);

const ExecutiveEducationSectionNav = ({ onNavClick }) => {
  const [activeSection, setActiveSection] = useState("overview");
  const navRef = useRef(null); 

  const handleNavClick = (id) => {
    setActiveSection(id); 
    onNavClick(id); 
  };

  return (
    <div className="sticky top-0 h-screen h--[calc(100vh-7rem)] bg-sddarkgray border-y-2 border-sdorange overflow-y-auto custom-scrollbar">
      <nav className="p-5">
        <ul className="space-y-4">
          {sections.map((section, index) => (
            <NavItem
              key={section.id}
              id={section.id}
              label={section.label}
              onClick={handleNavClick}
              isActive={activeSection === section.id}
              showLine={index < sections.length - 1}
              navRef={navRef}
            />
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default ExecutiveEducationSectionNav;
